import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AutoDestroy } from 'src/app/decorator/auto-destroy.decorator';
import { IError } from '../../model/backup-code.model';
import { distinctUntilChanged, take, takeUntil } from 'rxjs/operators';
import { SharedService } from '../../../shared/shared.service';
import { ITenantInfo } from '../../../shared/model/IMfa.model';
import { IErrorData, IUiError } from '../../../shared/model/IError.model';

@Component({
  selector: 'verification-backup-code',
  templateUrl: './backup-code.component.html',
  styleUrls: ['./backup-code.component.scss'],
})
export class BackupCodeComponent implements OnInit {
  @Input() config!: ITenantInfo;
  @Input() track_id!: string;

  @Output() checkBackupCodeStatus = new EventEmitter();
  // rxjs subject to handle the component destroy
  @AutoDestroy destroy$: Subject<boolean> = new Subject<boolean>();
  errorState$ = new BehaviorSubject(<IUiError>{});
  successState$ = new Subject();
  backupCodes$ = new BehaviorSubject([]);
  backupCodeEnrolledResponse: any = {};

  continueBtnOptions = {
    color: 'accent',
    text: 'SUGGESTED_VERIFICATION_METHOD.CONTINUE',
    alignment: 'right',
    type: 'proceed',
    underline: 'none',
    for: 'cidaasSubmitBtn',
    translateArgs: {},
  };

  constructor(private _sharedService: SharedService) {}

  ngOnInit(): void {
    if (this.track_id && Object.keys(this.config || {}).length) {
      //resetting the status
      this.successState$.next({});
      this.errorState$.next(<IUiError>{});
      this._sharedService
        ._initiateSuggestVerification(this.track_id, 'backupcode')
        .pipe(takeUntil(this.destroy$), distinctUntilChanged())
        .subscribe(
          (res:any) => {
              this.backupCodeEnrolledResponse = res;
              this.successState$.next(res);
              this.backupCodes$.next(res?.backup_codes);
          },
          (err) => {
            // preparing the error data for the UI
            const default_message = 'ERROR_CODES.SUGGEST_VERIFICATION.ENROLL_INITIATE.DEFAULT';
            const message = err.statusCode && err.code
                  &&`ERROR_CODES.SUGGEST_VERIFICATION.ENROLL_INITIATE.STATUS_${err.code}`
                  || default_message;
            this.errorState$.next({message, default_message, status: err.statusCode});
          }
        );
    };
  }

  /**
   *
   * @param status will hold wether its completed or failed
   */
  _backToSuggestVerificationList = (status: string) => {
    const response: any = { status: status, data: this.backupCodeEnrolledResponse };
    this.checkBackupCodeStatus.emit(response);
  };
}
